<template>
  <div class="forgot">
    <Header/>
    
    <div class="breadcrumb-area gray-bg">
            <div class="container">
                <div class="breadcrumb-content">
                    <ul>
                        <li><router-link to="/">Home</router-link></li>
                        <li class="active"> Forgot password </li>
                    </ul>
                </div>
            </div>
		</div>

    <div class="about-us-area pt-25 pb-25">
			<div class="container">
				<h3 class="page-title">Forgot Password</h3>
						<div class="grand-totall bg-white">
							<div class="row">
								<div class="col-lg-12 form-group">					
									<div v-if="successResponse" class="alert alert-success rounded" role="alert">
										<i class="fa fa-check-square fa-lg px-2"></i> Password reset email sent successfully!											
									</div>	

									<div v-if="errorResponse" class="alert alert-danger rounded" role="alert">
										<i class="fa fa-times fa-lg px-2"></i> {{errorMsg}}									
									</div>	

									<p class="text-dark"><i class="fa fa-exclamation-triangle fa-lg mr-2 active-star"></i> 
									Please enter the e-mail address associated with your account. We will send you a link to this e-mail address to reset your password.</p>
								</div>

								<div class="col-lg-6 col-12 form-group">
									<label>Email Address</label>
									<input class="form-control input-sm rounded" ref="email" type="email"/>

									<a class="golden-btn mt-4 rounded" @click="resetPassword()">
										<span class="btn_text text-white" v-show="!loader">Send Link</span>
										<i class="fa fa-spinner fa-spin mt-2 text-white" v-show="loader"></i>
									</a>
								</div>
							</div>
					</div>		
			</div>
		</div>

    <Footer/>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import User from "../apis/user"

export default {
  name: 'ForgotPassword',
  components: {
    Header,
    Footer
  },

	data: function () {
      return {
        loader: false,
				errorResponse: false,
				errorMsg: null,
				successResponse: false
      };
    },

	methods: {
		resetPassword() {
			var that = this;
			this.loader = true;
			var data = {};

			data.email = this.$refs.email.value,

			User.forgot(data)
				.then((response) => {
					that.loader = false;    
					
					if(response.data == "success") {
						that.successResponse = true;
						that.errorResponse = false;
					}  
					else {
						that.errorResponse = true;
						that.errorMsg = response.data

						that.successResponse = false;
					}   
				})
				.catch(function (err) {
					that.loader = false;    

					that.errorResponse = true;
					that.errorMsg = err.response.data.message

					that.successResponse = false;	
				});
		}
	}
}
</script>
